import React from 'react';
import { Box } from '@mui/material';
import { CasesFilters } from './CasesFilters';
import { FilterState, FilterActions } from './types';

interface FiltersProps extends FilterState, FilterActions {
  practiceAreas: string[];
}

export const Filters: React.FC<FiltersProps> = ({
  searchQuery,
  statusFilter,
  practiceAreaFilter,
  advancedFilters,
  practiceAreas,
  onSearchChange,
  onStatusChange,
  onPracticeAreaChange,
  onAdvancedFilterAdd,
  onAdvancedFilterRemove,
  onClearFilters,
}) => {
  const [advancedMenuAnchor, setAdvancedMenuAnchor] = React.useState<null | HTMLElement>(null);

  const handleAdvancedClick = (event: React.MouseEvent<HTMLElement>) => {
    setAdvancedMenuAnchor(event.currentTarget);
  };

  const handleAdvancedClose = () => {
    setAdvancedMenuAnchor(null);
  };

  return (
    <Box>
      <CasesFilters
        searchQuery={searchQuery}
        statusFilter={statusFilter}
        practiceAreaFilter={practiceAreaFilter}
        practiceAreas={practiceAreas}
        onSearchChange={onSearchChange}
        onStatusChange={onStatusChange}
        onPracticeAreaChange={onPracticeAreaChange}
        onClearFilters={onClearFilters}
        advancedFilters={advancedFilters}
        onAdvancedFilterAdd={onAdvancedFilterAdd}
        onAdvancedFilterRemove={onAdvancedFilterRemove}
        advancedMenuAnchor={advancedMenuAnchor}
        onAdvancedMenuClose={handleAdvancedClose}
        onAdvancedClick={handleAdvancedClick}
      />
    </Box>
  );
};